import axiosInstance from "../../config/Axios";

export const getServiceLevel = async (filters = {}) => {
  try {
    return await axiosInstance({
      method: "get",
      url: "/api/feedback/service-levels/",
      params: filters,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getServiceLevelById = async (id) => {
  try {
    return await axiosInstance({
      method: "get",
      url: `/api/feedback/service-levels/${id}/`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createServiceLevel = async (serviceLevelData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/feedback/service-levels/",
      data: serviceLevelData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateServiceLevel = async (id, serviceLevelData) => {
  try {
    return await axiosInstance({
      method: "put",
      url: `/api/feedback/service-levels/${id}/`,
      data: serviceLevelData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteServiceLevel = async (id) => {
  if (!id) {
    return Promise.reject(new Error("Service Level ID is required"));
  }
  try {
    const response = await axiosInstance({
      method: "delete",
      url: `/api/feedback/service-levels/${id}/`,
    });
    return response;
  } catch (error) {
    console.error("Delete API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
};

export default {
  getServiceLevel,
  getServiceLevelById,
  createServiceLevel,
  updateServiceLevel,
  deleteServiceLevel,
};
